import styled from 'styled-components';
import ClearIcon from '@mui/icons-material/Clear';
import { TextField } from '@mui/material';
import SearchIcon from '../../assets/icons/search-icon.svg';

export const StyledContainer = styled.div.attrs({ className: 'dsc-searchInput' })`
  display: flex;
  align-items: center;
  padding: 10px;
`;

export const StyledSearchIcon = styled(SearchIcon)`
  && {
    cursor: pointer;
    color: var(--select-text-color);
    font-size: 18px;
  }
`;

export const StyledClearIcon = styled(ClearIcon)`
  && {
    cursor: pointer;
    color: var(--select-text-color);
    font-size: 15px;
    visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  }
`;

export const StyledSearch = styled(TextField)`
  && {
    height: 32px;
    width: ${({ $width }) => `${$width}px`};
    padding-right: unset;

    .MuiFormHelperText-root {
      position: absolute;
      bottom: -20px;
      left: 0;
      font-size: 12px;
      color: var(--error);
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: var(--inputFocusedColor);
      border-width: 1px;
    }
    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: var(--inputFocusedColor);
        border-width: 1px;
      }
    }
    .MuiOutlinedInput-root {
      height: 100%;
      padding-right: unset;
      border-radius: var(--input-border-radius);
      background-color: var(--select-bg-color);

      fieldset {
        border-color: ${({ $error }) =>
          $error ? 'var(--error, rgb(220, 56, 49)) !important' : 'var(--inputBorderColor)'};
      }
    }

    .MuiOutlinedInput-adornedEnd {
      padding-right: unset;
    }
    .MuiInputBase-input {
      background-color: unset;
      padding: unset;
      font-size: 14px;
      color: var(--select-text-color);

      &::placeholder {
        color: var(--input-placeholder-color);
      }
    }
    .MuiFormHelperText-root {
      position: absolute;
      top: 32px;
      margin-top: unset;
    }
  }
`;
